const CONSOLE = 'https://console.cloud.google.com/storage/browser';

/** The Cloud Console page for a `gs://` uri: the bucket browser for a prefix, the object
 * details for a file; `null` for anything else. A last segment without an extension is a
 * prefix too, as run outputs are stored without the trailing slash. */
export function gcsConsoleUrl(uri: string | null | undefined): string | null {
  if (!uri?.startsWith('gs://')) return null;
  const path = uri.slice('gs://'.length);
  if (!path || path.startsWith('/')) return null;
  if (path.endsWith('/')) return `${CONSOLE}/${encodeURI(path.slice(0, -1))}`;
  if (!/\.[A-Za-z0-9]+$/.test(path.slice(path.lastIndexOf('/') + 1))) return `${CONSOLE}/${encodeURI(path)}`;
  return `${CONSOLE}/_details/${encodeURI(path)}`;
}
